var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-content-wrapper gray" }, [
    _c(
      "div",
      { staticClass: "go-container mypage sub" },
      [
        _c("div", { staticClass: "go-layout-wrap" }, [
          _c("div", { staticClass: "go-layout-header" }, [
            _c("div", { staticClass: "go-layout-path" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myPage")))]),
              _vm._v(" "),
              _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myAccount")))]),
              _vm._v(" "),
              _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("myPage.common.deleteAccount"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-layout-title" }, [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-expanded": "false",
                  },
                  on: { click: _vm.back },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-arrow-left" })]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "go-page-header-type2" }, [
                _c("div", { staticClass: "go-page-title" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.common.deleteAccount"))),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-layout-content" }, [
            _c("div", { staticClass: "go-panel go-panel-common sub-nav" }, [
              _c("div", { staticClass: "go-panel-body" }, [
                _c("div", { staticClass: "mypage-depth" }, [
                  _c("ul", [
                    _c("li", { staticClass: "mypage-depth-warning" }, [
                      _c("p", [
                        _c("i", { staticClass: "go-icon-24 go-icon-close" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("myPage.delete.title"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("myPage.delete.description"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("div", { staticClass: "go-form-feedback-help" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.deleteAccount()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("myPage.common.deleteAccount"))
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.getIsOpenFirstStepDeleteAccountModal
          ? _c("deleteAccountFirstStepComponent")
          : _vm._e(),
        _vm._v(" "),
        _vm.getIsOpenSecondStepDeleteAccountModal
          ? _c("deleteAccountSecondStepComponent")
          : _vm._e(),
        _vm._v(" "),
        _vm.getIsOpenFirstStepDeleteAccountModal ||
        _vm.getIsOpenSecondStepDeleteAccountModal
          ? _c("div", { staticClass: "modal-backdrop fade show" })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }